import { ModalVariants } from "@hid-galaxy-ui/galaxy-react/components/Modal/modalEnums";
import React, { ReactNode } from "react";
import RPLModal from "@hid-galaxy-ui/galaxy-react/components/Modal"

export interface IModalProps {
    headerText?: string;
    children: ReactNode;
    className?: string;
    size?: ModalVariants;
    width?: number;
    optionalHeader?: string;
    isDisplayCloseIcon?: boolean;
    onClose: (e: React.MouseEvent<HTMLButtonElement>) => void;
    // id?: string;
    isFocusTrapActive?: boolean;
    footerConfig?: {
        primaryBtnLabel: string;
        secondaryBtnLabel: string;
        onClickPrimaryBtn: () => void;
    }
  }
const Modal = (props: IModalProps) => {

    const {headerText, children,onClose,footerConfig, isFocusTrapActive = false, isDisplayCloseIcon = false} = props
  return (
  <RPLModal 
  size={ModalVariants.Medium}
  headerText={headerText}
  isDisplayCloseIcon={isDisplayCloseIcon}
  isFocusTrapActive={isFocusTrapActive}
  onClose={onClose}
  footerConfig={footerConfig}
  >
    {children}
  </RPLModal>
  );
};

export default Modal;